export type PathRoute = 'callback' | 'howto' | 'join' | null;

/** Path-based routes; null means "decide by role" (display vs phone at `/`). */
export function resolvePath(path: string): { route: PathRoute; code: string } {
  if (path === '/callback') return { route: 'callback', code: '' };
  if (path === '/how-to-play' || path === '/how-to-play/') return { route: 'howto', code: '' };
  const m = /^\/([A-Za-z]{4})$/.exec(path);
  if (m) return { route: 'join', code: m[1] };
  return { route: null, code: '' };
}
